import { AccountPosition } from '../../type';
import { spRatingWithDefault } from '../../../../shared';

export const spRatingWithDefaultFromAccountPosition = (accountPosition: AccountPosition | null | undefined) => (accountPosition ? spRatingWithDefault(accountPosition['GES_RAT_VAL_SP.SHORTCUT']) : '');
